import { FontIcon, IRawStyle, memoizeFunction, mergeStyles, Stack, Text } from "@fluentui/react";
import React, { useCallback } from "react";
import {
    cameraOffLabelStyle,
    localPreviewContainerStyleDesktop,
    localPreviewContainerStyleMobile,
    getLocalPreviewTileStyle,
} from "../styles/LocalPreview.styles";
import { StreamMedia, useTheme, VideoTile } from "@azure/communication-react";
import { LocalPreviewControlBar } from "./LocalPreviewControlBar";
import { localPreviewSelector, usePcpLiveLessonContext } from "../store";
import { fillWidthAndHeightStyles } from "../styles";

const localPreviewPlaceholderStyles = memoizeFunction(
    (neutralTertiary: string) => mergeStyles(cameraOffLabelStyle, { color: neutralTertiary })
);
const cameraTurnedOffTextStyles = memoizeFunction(
    (neutralSecondary: string) => mergeStyles(cameraOffLabelStyle, { color: neutralSecondary })
);

export interface LocalPreviewProps {
    mobileView: boolean;
    styles?: IRawStyle;
}

export const LocalPreview = (props: LocalPreviewProps): JSX.Element => {

    const { mobileView, styles } = props;

    // const locale = useLocale();
    const localPreviewProps = usePcpLiveLessonContext(localPreviewSelector);
    const videoStreamElement = localPreviewProps?.videoStreamElement;

    const theme = useTheme();
    const onRenderPlaceholder = useCallback((): JSX.Element =>
         (
            <Stack
                className={mergeStyles(fillWidthAndHeightStyles)}
                verticalAlign="center"
                tokens={{ childrenGap: '0.25rem' }}
            >
                <Stack.Item align="center">
                    <FontIcon
                        iconName="LocalPreviewPlaceholder"
                        className={localPreviewPlaceholderStyles(theme.palette.neutralTertiary)}
                    />
                </Stack.Item>
                <Stack.Item align="center">
                    <Text className={cameraTurnedOffTextStyles(theme.palette.neutralSecondary)}>
                        {/*{locale.strings.call.cameraTurnedOff}*/}
                        Camera turned off
                    </Text>
                </Stack.Item>
            </Stack>
        )
    // }, [theme, locale.strings.call.cameraTurnedOff]);
    , [theme]);

    // const dm = useDeviceManager();
    // useEffect(() => {
    //     (async () => {
    //         if (!dm) {
    //             return;
    //         }
    //
    //         const access = await dm.askDevicePermission({ video: true, audio: true });
    //         const views = dm.getUnparentedVideoStreams();
    //
    //         console.log(views);
    //     })();
    // }, [dm]);

    const containerStyles = React.useMemo(() => mergeStyles(
        mobileView ? localPreviewContainerStyleMobile : localPreviewContainerStyleDesktop,
        styles ?? {}
    ), [mobileView, styles]);

    return (
        <Stack
            data-ui-id="call-composite-local-preview"
            className={containerStyles}
        >
            <VideoTile
                styles={getLocalPreviewTileStyle()}
                renderElement={
                    videoStreamElement ? (
                        <StreamMedia videoStreamElement={videoStreamElement} />
                    ) : undefined
                }
                onRenderPlaceholder={onRenderPlaceholder}
            >
            </VideoTile>
            <LocalPreviewControlBar
                mobileView={mobileView}
            ></LocalPreviewControlBar>
        </Stack>
    );
};
